import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=fdbe7094&"
import script from "./SuccessMessage.vue?vue&type=script&lang=js&"
export * from "./SuccessMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports